const state = {
  fieldList: [], // 字段列表
  instanceCodeOptions: [], // 实例code列表
  selectTool: '',
  material_name: 'text'
}
const mutations = {
  SET_FIELD_LIST(state, vo) {
    state.fieldList = vo
  },
  SET_INSTANCE_CODE_OPTIONS(state, vo) {
    state.instanceCodeOptions = vo
  },
  SET_SELECT_TOOL(state, value) {
    state.selectTool = value
  },
  SET_material_name(state, value) {
    state.material_name = value
  }
}
const actions = {
  setFieldList({ commit }, vo) {
    commit('SET_FIELD_LIST', vo)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
